export const zoomResolution = {
  day: 4,
  hour: 12,
};
